import { Dialog, DialogContent, Stack, styled } from '@mui/material'
import React from 'react'
import { ReactComponent as QueenThai } from '@Assets/images/QueenTh.svg'
import QueenBackground from '@Assets/images/QueenThBackground.png'
import { ReactComponent as QueenDesc1 } from '@Assets/images/QueenDesc1.svg'
import { ReactComponent as QueenDesc2 } from '@Assets/images/QueenDesc2.svg'
import { ReactComponent as QueenDesc3 } from '@Assets/images/QueenDesc3.svg'
import { ReactComponent as QueenIcon } from '@Assets/images/QueenIcon.svg'

const ModalRIPpage = ({ open, handleClose }) => {

    return (
        <DialogStyled fullScreen open={open} style={{ zIndex: 0 }}>
            <DialogContentStyled style={{ backgroundImage: `url(${QueenBackground})` }}>
                <Stack
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '30px',
                    justifyContent: 'center',
                    alignItems: 'center',
                    maxWidth: '100%',
                    maxHeight: '100%',

                    '@media screen and (min-width: 1280px)': {
                      flexDirection: 'row',
                      // gap: '100px',
                      alignItems: 'center',
                      height: '100%',
                    },

                    '@media screen and (min-width: 2000px)': {
                      gap: '200px'
                    }
                  }}
                >
                  <Stack 
                    sx={{ 
                      maxWidth: '200px',
                      '@media screen and (min-width: 600px)': {
                        maxWidth: '300px'
                      },
                      
                      '@media screen and (min-width: 1280px)': {
                        maxWidth: '526px',
                        maxHeight: '100%',
                        width: '50%'
                      }
                    }}
                  >
                    <QueenThai style={{ width: 'auto', height: 'auto', maxWidth: '100%', maxHeight: '100%'}} />
                  </Stack>

                  <Stack sx={{ 
                    maxWidth: '556px', 
                    justifyContent: 'center', 
                    alignItems: 'center', 
                    gap: '20px',
                    '@media screen and (min-width: 1280px)': {
                      width: '100%',
                      gap: '30px'
                    }
                  }}>
                    <Stack sx={{ gap: '10px' }}>
                      <QueenDesc1 style={{ width: 'auto', height: 'auto', maxWidth: '100%', maxHeight: '100%'}} />
                      <QueenDesc2 style={{ width: 'auto', height: 'auto', maxWidth: '100%', maxHeight: '100%'}} />
                    </Stack>

                    <QueenIcon style={{ width: '60%', height: '100%', maxWidth: '284px', maxHeight: '100%'}} />
                    
                    <Stack 
                    sx={{ 
                      maxWidth: '200px',
                      '@media screen and (min-width: 600px)': {
                        maxWidth: '300px'
                      }
                    }}>
                      <QueenDesc3 style={{ maxWidth: '100%', maxHeight: '100%', width: 'auto', height: 'auto'}} />
                    </Stack>

                    <ButtonStyled disableRipple disableTouchRipple disableFocusRipple onClick={handleClose}>
                        เข้าสู่เว็บไซต์
                    </ButtonStyled>
                  </Stack>
                </Stack>
            </DialogContentStyled>
        </DialogStyled>
    )
}

const DialogStyled = styled(Dialog)`
  & .MuiDialog-paper {
    width: 100vw;
  }
`
const DialogContentStyled = styled(DialogContent)`
  margin-top: 65px;
  padding: 30px 24px;
  
  background-color: black;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  background-size: cover;
  background-repeat: no-repeat;
  object-fit: cover;
  background-position: center;

  @media screen and (min-width: 429px) {
    margin-top: 75px;
  }
  
  @media screen and (min-width: 834px) {
    margin-top: 100px;
    background-position: unset;
  }

  @media screen and (min-width: 1280px) {
    display: unset;
  }
`

const ButtonStyled = styled('button')`
  background-color: #9B9B9B;
  border-radius: 99px;
  cursor: pointer;
  width: 162px;
  height: 46px;
  padding: 0;
  margin-top: 10px;

  font-size: 20px;
  font-weight: 400;
  color: #000000;

`
export default ModalRIPpage